import InputRadioGroup from './input-radio-group-view'

export default InputRadioGroup
